import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin: 0;
  padding: 24px 12px;

  ${mediaMixin(
    'md',
    css`
      flex-direction: row;
      margin: 16px 0;
      padding: 24px 48px;
    `,
  )};
`;

export const Details = styled.div`
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  margin-left: 20px;
  margin-right: auto;
  ${mediaMixin(
    'md',
    css`
      margin: 0;
    `,
  )};
`;
